export default (value: number, length: number): number[] => {
  if (value > 0) {
    return new Array(length).fill(0.5, 0, length);
  } else if (value < 0) {
    return new Array(length).fill(0.5, 0, length);
  }
  return new Array(length).fill(0, 0, length);
};
